import { ActionIcon } from '@mantine/core';
import { Trash2Icon } from 'lucide-react';
import styles from './DeleteButton.module.css';

const DeleteButton = ({
  label,
  onDelete,
}: {
  label: string;
  onDelete: () => void;
}) => {
  return (
    <ActionIcon
      aria-label={label}
      onClick={onDelete}
      className={styles.deleteButton}
    >
      <Trash2Icon size={16} />
    </ActionIcon>
  );
};

export default DeleteButton;
